import { StatusBlock } from "screens/partials/ecommerce/components/blocks/status-block";
import { WelcomeBlock } from "screens/partials/ecommerce/components/blocks/welcome-block";
import OrdersBlock from "screens/partials/ecommerce/components/blocks/orders-block";
import EarningBlock from "screens/partials/ecommerce/components/blocks/earning-block";
import { Box, ShoppingCart, TrendingUp } from "lucide-react";
import RevenueBarChart from "./components/revenue-bar-chart";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card";
import DashboardDropdown from "./components/dashboard-dropdown";
import RecentOrderTable from "./components/recent-order-table";
import VisitorsReportChart from "./components/visitors-report";
import { products } from "./components/data";
import Product from "./components/product";
import WidgetBg2Img from "images/all-img/widget-bg-2.png";
import { useUserData } from "store/user-data";
import React, { useEffect, useState } from "react";
import Loading from "components/loading";
import { getStatisticsAction, Statistics } from "action/stat-action";
import { useStatsData } from "store/stats-data";
import { useSessionControl } from "hooks/use-session-control";

const StorboltEcommerceComponent = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [statsData, setStatsData] = useState<Statistics | null>(null);
    const [greeting, setGreeting] = useState('');
    const _statsData = useStatsData.getState().statsData
    const { sessionControl } = useSessionControl();

    const handleGreeting = () => {
        const currentHour = new Date().getHours();

        if (currentHour < 12) {
            setGreeting('Good Morning');
        } else if (currentHour < 18) {
            setGreeting('Good Afternoon');
        } else {
            setGreeting('Good Evening');
        }
    }

    useEffect(() => {
        handleGreeting();

        if (_statsData.total_revenue != null) {
            setStatsData(_statsData);
            setIsLoading(false);
        } else {
            getStatisticsAction().then((response) => {
                if (response.status === 401) {
                    sessionControl(response.status);
                    return
                }
                useStatsData.getState().setStatsData(response.data);
                setStatsData(response.data);
                setIsLoading(false);
            })
        }

    }, []);

    return (
        isLoading ? <div className="h-screen"><Loading/></div> :
            <div className="space-y-5 overflow-x-hidden">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
                    <WelcomeBlock>
                        <div className="max-w-[180px] relative z-10">
                            <h4 className="text-xl font-medium text-primary-foreground dark:text-default-900 mb-2">
                                <span className="block font-normal">{greeting}</span>
                                <span className="block">{useUserData.getState().userData.username}</span>
                            </h4>
                            <p className="text-sm text-primary-foreground dark:text-default-900 font-normal">
                                Your Storbolt Dashboard
                            </p>
                        </div>
                        {/*<img*/}
                        {/*    src={WidgetBg2Img}*/}
                        {/*    width={400}*/}
                        {/*    height={150}*/}
                        {/*    loading={"eager"}*/}
                        {/*    alt="storbolt dashboard"*/}
                        {/*    className="absolute top-0 start-0 w-full h-full object-cover rounded-md"*/}
                        {/*/>*/}
                    </WelcomeBlock>
                    <StatusBlock
                        title="Total Revenue"
                        timeline="All Time"
                        total={`₦${statsData.total_revenue.toLocaleString()}`}
                        iconWrapperClass="bg-info/10"
                        chartColor="#00EBFF"
                        icon={<ShoppingCart className="w-5 h-5  text-info"/>}
                    />
                    <StatusBlock
                        title="Products Sold"
                        timeline="All Time"
                        total={statsData.total_products_sold_count}
                        icon={<Box className="w-5 h-5 text-warning"/>}
                        iconWrapperClass="bg-warning/10"
                        chartColor="#FB8F65"
                    />
                    <StatusBlock
                        title="Growth"
                        timeline="From Last Week"
                        total={`${(statsData.growth_rate * 100).toFixed(0)}%`}
                        icon={<TrendingUp className="w-5 h-5 text-primary"/>}
                        iconWrapperClass="bg-primary/10"
                        chartColor="#2563eb"
                    />
                </div>
                <div className="grid grid-cols-12 gap-5">
                    <div className="col-span-12 lg:col-span-8">
                        <Card>
                            <CardHeader className="flex flex-row items-center gap-1">
                                <CardTitle className="flex-1">Revenue Report</CardTitle>
                                {/*<DashboardDropdown/>*/}
                            </CardHeader>
                            <CardContent className="pt-5">
                                <RevenueBarChart height={420}/>
                            </CardContent>
                        </Card>
                    </div>
                    <div className="col-span-12 lg:col-span-4">
                        <Card>
                            <CardHeader className="flex flex-row items-center gap-1">
                                <CardTitle className="flex-1">Statistics</CardTitle>
                                {/*<DashboardDropdown/>*/}
                            </CardHeader>
                            <CardContent>
                                <div className="grid grid-cols-2  gap-5">
                                    <div className="col-span-2 md:col-span-1">
                                        <OrdersBlock
                                            title="Orders"
                                            total={statsData.total_orders}
                                            chartColor="#f1595c"
                                            className="border-none shadow-none bg-default-50 "
                                        />
                                    </div>
                                    <div className="col-span-2 md:col-span-1">
                                        <OrdersBlock
                                            title="Conversion Rate"
                                            total={`${(statsData.conversion_rate).toFixed(1)}%`}
                                            chartColor="#4669fa"
                                            chartType="line"
                                            percentageContent={
                                                <span className="text-primary">+2.5%</span>
                                            }
                                            className="border-none shadow-none bg-default-50 col-span-2 md:col-span-1"
                                        />
                                    </div>
                                    <div className="col-span-2">
                                        <EarningBlock
                                            title="Average Order Value"
                                            total={`₦${statsData.average_order_value.toLocaleString()}`}
                                            className="col-span-2 border-none shadow-none bg-default-50"
                                        />
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    </div>
                </div>
                {/*<div className="grid gap-5 lg:w-full">*/}
                {/*    <Card>*/}
                {/*        <CardHeader className="flex flex-row items-center gap-1">*/}
                {/*            <CardTitle className="flex-1">Revenue Report</CardTitle>*/}
                {/*            /!*<DashboardDropdown/>*!/*/}
                {/*        </CardHeader>*/}
                {/*        <CardContent className="px-0">*/}
                {/*            <RevenueBarChart height={420}/>*/}
                {/*        </CardContent>*/}
                {/*    </Card>*/}
                {/*</div>*/}
                <div className="grid gap-5 w-full">
                    <div className="lg:col-span-8 col-span-12">
                        <Card>
                            <CardHeader className="flex flex-row items-center gap-1">
                                <CardTitle className="flex-1">Visitors Report</CardTitle>
                                {/*<DashboardDropdown/>*/}
                            </CardHeader>
                            <CardContent>
                                <VisitorsReportChart height={350}/>
                            </CardContent>
                        </Card>
                    </div>
                </div>
                <div className="grid lg:grid-cols-2 grid-cols-1 gap-5">
                    {/*<MostSales />*/}
                    <Card>
                        <CardHeader className="flex flex-row items-center gap-1">
                            <CardTitle className="flex-1">
                                Best Selling Products
                            </CardTitle>
                            {/*<DashboardDropdown/>*/}
                        </CardHeader>
                        {statsData.product_stats?.length === 0 ?
                            <div className='flex justify-center items-center py-10'>
                                No Data Available
                            </div> : <CardContent>
                                <div className="grid md:grid-cols-3 grid-cols-1 gap-5">
                                    {statsData.product_stats?.map((product, index) => (
                                        <Product key={index} product={product}/>
                                    ))}
                                </div>
                            </CardContent>}
                    </Card>
                </div>
            </div>
    );
};

export default StorboltEcommerceComponent;
